import { createSlice } from '@reduxjs/toolkit';
import { getUserInstitutions } from './thunks';

const initialState = {
  institutions: [],
  institutionsLoading: false,
  institutionsError: false,
  institutionsLoaded: false,
};

const slice = createSlice({
  name: 'institutions',
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [getUserInstitutions.fulfilled]: (state, { payload }) => {
      state.institutions = payload;
      state.institutionsLoading = false;
      state.institutionsError = false;
      state.institutionsLoaded = true;
    },
    [getUserInstitutions.pending]: state => {
      state.institutions = [];
      state.institutionsLoading = true;
      state.institutionsError = false;
      state.institutionsLoaded = false;
    },
    [getUserInstitutions.rejected]: state => {
      state.institutions = [];
      state.institutionsLoading = false;
      state.institutionsError = true;
      state.institutionsLoaded = false;
    },
  },
});

export default slice.reducer;
